module.exports = __webpack_public_path__ + "static/media/01_NEI_190905_IMG.b7aed39c.jpg";